export default "__VITE_ASSET__DRJbD2We__"